import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

async function fetchConstantData(saleAreaId, projectId, department, employeeId) {
  const searchOptions = {
    limit: 10000000,
    page: 1,
  };

  // if (projectId){
  //   searchOptions.status = 'OPEN';
  // }
  const searchQueryParams = new URLSearchParams(searchOptions).toString();
  let customerQueryParams = searchQueryParams;

  if (employeeId) {
    customerQueryParams =
      customerQueryParams +
      "&" +
      new URLSearchParams({ employeeId }).toString();
  }
  
  // Fetch constant data concurrently
  const [paymentMethod, customer] = await Promise.all([
    clientAPI("get", `/paymentMethod?${searchQueryParams}`),
    clientAPI("get", `/customer?${customerQueryParams}`),
  ]);

  // Index data by 'id' to improve lookup performance
  return {
    paymentMethod: paymentMethod?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
    customer: customer?.items?.reduce(
      (acc, item) => ({ ...acc, [item._id]: item.name }),
      {}
    ),
  };
}

export function useCategories(saleAreaId, projectId, department, employeeId, shouldFetch) {
  // Fetch constant data once
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["categories30", saleAreaId, projectId, department, employeeId],
    queryFn: () => fetchConstantData(saleAreaId, projectId, department, employeeId),
    enabled: shouldFetch,
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}
